// extracted by mini-css-extract-plugin
export default {"container":"Dnx0V0","badge":"LlobFR","fullWidth":"ZDnSD3"};